var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tripLeft" },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "firstLine" }, [
          _c(
            "div",
            {
              staticStyle: { width: "20%" },
              style:
                _vm.costPrice > 0 || _vm.planCollectionPriceDaiFu1 > 0
                  ? ""
                  : "text-align:center",
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "bold", "font-size": "0.2rem" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$store.state.planId
                        ? _vm.$store.state.planId
                        : "请先选择一个方案或者创建方案"
                    )
                  ),
                ]
              ),
              _c("span", { staticClass: "planNumber" }, [_vm._v("方案编号")]),
            ]
          ),
          _vm.costPrice > 0 || _vm.planCollectionPriceDaiFu1 > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    width: "78%",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "priceDiv",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goMyCollection(1)
                        },
                      },
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "0.12rem" } }, [
                        _vm._v("收"),
                      ]),
                      _c("div", [
                        _c("span", { staticStyle: { margin: "0 0.1rem" } }, [
                          _vm._v("实收"),
                        ]),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(Number(_vm.planCollectionPriceDaiFu1))),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "priceDiv",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goMyCollection(1)
                        },
                      },
                    },
                    [
                      _c("div", { staticStyle: { "font-size": "0.12rem" } }, [
                        _vm._v("支"),
                      ]),
                      _c("div", [
                        _c("span", { staticStyle: { margin: "0 0.1rem" } }, [
                          _vm._v("实付"),
                        ]),
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(Number(_vm.payCostPrice.toFixed(2)))),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.costPrice > 0 || _vm.planCollectionPriceDaiFu1 > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "priceDiv",
                          staticStyle: { "margin-right": "0.3rem" },
                        },
                        [
                          _c("div", [_vm._v("¥")]),
                          _c("div", { staticStyle: { color: "#DB4E1A" } }, [
                            _c(
                              "span",
                              { staticStyle: { margin: "0 0.1rem" } },
                              [_vm._v("结余")]
                            ),
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    Number(
                                      (
                                        _vm.planCollectionPriceDaiFu1 +
                                        _vm.commissionPrice -
                                        _vm.payCostPrice
                                      ).toFixed(2)
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "secondLine" }, [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "budgetDiv" }, [
              _c(
                "div",
                { staticClass: "tubiao" },
                [
                  _c("svg-icon", {
                    staticStyle: { width: "10px", height: "10px" },
                    attrs: { iconClass: "send" },
                  }),
                ],
                1
              ),
              _c("span", [
                _vm._v(
                  "报价" +
                    _vm._s(
                      _vm.budgetList.findIndex(
                        (ee) => ee.id == _vm.chenckBudget.id
                      ) + 1
                    )
                ),
              ]),
              _vm.budgetList.length > 1
                ? _c("span", { on: { click: _vm.changeBudget } }, [
                    _vm._v("切换报价单"),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              [
                _c("div", { staticClass: "budgetInfoDiv" }, [
                  _c("div", { staticClass: "leftInfo" }, [
                    _c("p", [
                      _c(
                        "span",
                        {
                          style:
                            _vm.costPrice > 0 ||
                            _vm.planCollectionPriceDaiFu1 > 0
                              ? "color: #40b8ff;"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.chenckBudget.useNumber) + "人")]
                      ),
                      _c("span", [_vm._v("|")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.costPrice > 0 ||
                              _vm.planCollectionPriceDaiFu1 > 0
                              ? "有订单"
                              : "无订单"
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "p",
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.chenckBudget.planName,
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.updatePlanNameShow,
                                        expression: "!updatePlanNameShow",
                                      },
                                    ],
                                    staticClass: "planInfo",
                                    on: {
                                      click: function ($event) {
                                        _vm.updatePlanNameShow = true
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.chenckBudget.planName))]
                                ),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.updatePlanNameShow,
                                      expression: "updatePlanNameShow",
                                    },
                                  ],
                                  staticStyle: { width: "2rem" },
                                  attrs: { size: "mini" },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.updateBudgetMainName(2)
                                    },
                                  },
                                  model: {
                                    value: _vm.chenckBudget.newPlanName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.chenckBudget,
                                        "newPlanName",
                                        $$v
                                      )
                                    },
                                    expression: "chenckBudget.newPlanName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("p", [
                      _vm.customerName
                        ? _c(
                            "span",
                            { staticStyle: { color: "rgb(64, 184, 255)" } },
                            [_vm._v(_vm._s(_vm.customerName))]
                          )
                        : _c(
                            "span",
                            {
                              staticStyle: { color: "rgb(64, 184, 255)" },
                              on: { click: _vm.linkInquiry },
                            },
                            [_vm._v("暂无客户信息")]
                          ),
                    ]),
                  ]),
                  _c("div", {
                    staticStyle: {
                      "border-left": "1px solid #F2F2F2",
                      margin: "0px 0.1rem",
                    },
                  }),
                  _c("div", { staticClass: "rightInfo" }, [
                    _vm.$refs.planDetail
                      ? _c("div", [
                          _c(
                            "p",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showCostPrice = true
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "blueButton" }, [
                                _vm._v("成本"),
                              ]),
                              _vm._v("   "),
                              _c(
                                "span",
                                {
                                  style: _vm.showCostPrice
                                    ? "color: #DB4E1A;"
                                    : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      Number(_vm.$refs.planDetail.immediateCost)
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showCostPrice = false
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "blueButton" }, [
                                _vm._v("报价"),
                              ]),
                              _vm._v("   "),
                              _c(
                                "span",
                                {
                                  style: _vm.showCostPrice
                                    ? ""
                                    : "color: #DB4E1A;",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      Number(
                                        _vm.$refs.planDetail.immediateOffer
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("p", [
                            _c("span", { staticClass: "blueButton" }, [
                              _vm._v("利润"),
                            ]),
                            _vm._v(
                              "   " +
                                _vm._s(
                                  Number(
                                    (
                                      _vm.$refs.planDetail.immediateOffer -
                                      _vm.$refs.planDetail.immediateCost
                                    ).toFixed(2)
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", [
                  _c("p", [
                    _c(
                      "button",
                      {
                        staticClass: "blueButton",
                        on: {
                          click: function ($event) {
                            return _vm.booking(0)
                          },
                        },
                      },
                      [_vm._v("批量预定")]
                    ),
                  ]),
                  _c("p", [
                    _c(
                      "button",
                      {
                        staticClass: "blueButton",
                        on: {
                          click: function ($event) {
                            return _vm.collection()
                          },
                        },
                      },
                      [_vm._v("操作确认")]
                    ),
                  ]),
                  _c("p", [
                    _c(
                      "button",
                      {
                        staticClass: "blueButton",
                        on: { click: _vm.budgetDetail },
                      },
                      [_vm._v("预算明细")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "right", staticStyle: { display: "flex" } },
            [
              _c("div", { staticClass: "colletionDiv" }, [
                _c(
                  "p",
                  { staticStyle: { color: "#87888A", "font-size": "0.15rem" } },
                  [_vm._v("收款订单")]
                ),
                _c("div", [
                  _c(
                    "p",
                    {
                      staticStyle: { "margin-top": "0.1rem" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goMyCollection(2)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "spanlabel" }, [
                        _vm._v("应收"),
                      ]),
                      _vm._v(
                        "  " +
                          _vm._s(Number(_vm.totalPlanCollectionPrice)) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: { "margin-top": "0.1rem" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goMyCollection(1)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "spanlabel" }, [
                        _vm._v("已收"),
                      ]),
                      _vm._v("  " + _vm._s(Number(_vm.planCollectionPrice))),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticStyle: { "margin-top": "0.1rem" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.goMyCollection(0)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "spanlabel" }, [
                        _vm._v("待收"),
                      ]),
                      _vm._v(
                        "  " +
                          _vm._s(
                            Number(
                              (
                                _vm.totalPlanCollectionPrice -
                                _vm.planCollectionPrice
                              ).toFixed(2)
                            )
                          )
                      ),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "orderDiv",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.goMyOrder.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: { color: "#87888A", "font-size": "0.15rem" },
                    },
                    [_vm._v("支出订单")]
                  ),
                  _c("div", [
                    _c("p", { staticStyle: { "margin-top": "0.1rem" } }, [
                      _c("span", { staticClass: "spanlabel" }, [
                        _vm._v("总额"),
                      ]),
                      _vm._v("  " + _vm._s(Number(_vm.costPrice.toFixed(2)))),
                    ]),
                    _c("p", { staticStyle: { "margin-top": "0.1rem" } }, [
                      _c("span", { staticClass: "spanlabel" }, [
                        _vm._v("已付"),
                      ]),
                      _vm._v(
                        "  " + _vm._s(Number(_vm.payCostPrice.toFixed(2)))
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        staticStyle: { "margin-top": "0.1rem" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.goMyOrder(1)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "spanlabel" }, [
                          _vm._v("待付"),
                        ]),
                        _vm._v(
                          "  " +
                            _vm._s(
                              Number(
                                (_vm.costPrice - _vm.payCostPrice).toFixed(2)
                              )
                            )
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "buttonDiv",
                  staticStyle: { "padding-top": "0.18rem" },
                },
                [
                  _c("p", [
                    _c(
                      "button",
                      {
                        staticClass: "blueButton",
                        staticStyle: { padding: "0.03rem 0.2rem" },
                      },
                      [_vm._v("合同")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "blueButton",
                        staticStyle: { padding: "0.03rem 0.2rem" },
                        on: {
                          click: function ($event) {
                            return _vm.invoicePage()
                          },
                        },
                      },
                      [_vm._v("发票 ")]
                    ),
                  ]),
                  _vm._m(0),
                  _c("p"),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c("trip-detail", {
        ref: "planDetail",
        attrs: {
          budgetList: _vm.budgetList,
          chenckBudget: _vm.chenckBudget,
          hasCustomerName: _vm.hasCustomerName,
          hasOrderNumber: _vm.costPrice > 0,
          showCostPrice: _vm.showCostPrice,
        },
      }),
      _c("budget-detail-dialog", {
        ref: "budgetDetail",
        attrs: { chenckBudget: _vm.chenckBudget, planDetail: _vm.planDetail },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "orderDetailDialog",
          attrs: {
            "append-to-body": true,
            visible: _vm.orderDetailVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderDetailVisible = $event
            },
          },
        },
        [
          _c("my-colletion-order", {
            ref: "myCollectionOrder",
            staticStyle: { "margin-top": "0.2rem" },
            attrs: { planId: _vm.$store.state.planId, showSearch: false },
          }),
        ],
        1
      ),
      _c("CollectionNew", { ref: "collectionNew" }),
      _c(
        "el-dialog",
        {
          staticClass: "orderDetailDialog",
          attrs: {
            visible: _vm.orderDetailVisible1,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderDetailVisible1 = $event
            },
          },
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "0.25rem",
                color: "red",
                "font-weight": "bold",
              },
            },
            [
              _vm._v(
                "共 " +
                  _vm._s(_vm.total) +
                  " 个订单 勾选订单金额：" +
                  _vm._s(_vm.checkTheAmount) +
                  " 总计：" +
                  _vm._s(Number(_vm.costPrice.toFixed(2)))
              ),
            ]
          ),
          _c("static-table", {
            attrs: {
              dataType: _vm.dataType,
              loading: _vm.loading,
              tableData: _vm.tableData,
            },
            on: {
              orderSelect: _vm.getSelectOrderList,
              updateList: function ($event) {
                return _vm.getOrderList()
              },
            },
          }),
          _c("Pagination", {
            attrs: {
              pageSize: _vm.requestParameters.size,
              pageSizes: [20, 40, 80, 100],
              perPage: _vm.requestParameters.page,
              totalNumber: _vm.total,
            },
            on: { loadTable: _vm.loadTable },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.linkInquiryVisible,
            title: "关联询单",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.linkInquiryVisible = $event
            },
          },
        },
        [
          _c("el-autocomplete", {
            staticStyle: { width: "300px" },
            attrs: {
              "fetch-suggestions": _vm.querySearch,
              placeholder: "请输入你要关联的询单编号",
            },
            on: { select: _vm.handleSelect },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ item }) {
                  return [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(
                        "询单号:" +
                          _vm._s(item.id) +
                          "/" +
                          _vm._s(item.informationResult.travelDate) +
                          "/" +
                          _vm._s(item.informationResult.destination) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.linkInquiryId,
              callback: function ($$v) {
                _vm.linkInquiryId = $$v
              },
              expression: "linkInquiryId",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.linkInquiryVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.linkInquirySure },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("invoice-page", { ref: "invoicePage" }),
      _c(
        "el-dialog",
        {
          staticClass: "orderDetailDialog",
          attrs: {
            visible: _vm.updateBudgetDialog,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.updateBudgetDialog = $event
            },
          },
        },
        [
          _c("update-budget", {
            attrs: {
              budgetList: _vm.budgetList,
              chenckBudget: _vm.chenckBudget,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c(
        "button",
        {
          staticClass: "blueButton",
          staticStyle: { padding: "0.03rem 0.2rem" },
        },
        [_vm._v("名单")]
      ),
      _c(
        "button",
        {
          staticClass: "blueButton",
          staticStyle: { padding: "0.03rem 0.2rem" },
        },
        [_vm._v("导出")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }